import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as SolidHeart } from '@fortawesome/free-solid-svg-icons';
import { faHeart as RegularHeart } from '@fortawesome/free-regular-svg-icons';
import { useImage } from "../../context/ImageContext.js";
import './ProductCard.css';

const ProductCard = ({
    product,
    isFavorite,
    onFavoriteToggle,
    showGramPrice = true
}) => {
    const { getImageUrl } = useImage();

    const handleFavoriteClick = (e) => {
        if (e.button && e.button !== 0) {
            return;
        }

        e.stopPropagation();
        e.preventDefault();
        onFavoriteToggle(e, product);
    };

    return (

        <a
            href={`/urun/${product.sef}`
            }
            target="_blank"
            rel="noopener noreferrer"
            className="product-card"
            style={{ textDecoration: 'none', color: 'inherit' }}
        >
            <div className="product-img-container">
                <img
                    className='position-relative'
                    src={getImageUrl(product.image.i1)}
                    alt={product.baslik}
                    loading="lazy"
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/no-image.png";
                    }}
                />
                {product.eski_fiyat !== product.fiyat && (
                    <div className="discount-badge">
                        {/* {Math.floor(((product.eski_fiyat - product.fiyat) / product.eski_fiyat) * 100)}% */}
                        <div className='d-flex flex-column'>
                            {(((product.eski_fiyat - product.fiyat) / product.eski_fiyat) * 100).toFixed(1)}%
                            <span>İndirim</span>
                        </div>
                    </div>
                )}
                <div
                    onClick={handleFavoriteClick}
                    onMouseDown={(e) => {
                        if (e.button === 1) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                    }}
                    className="favorite-icon p-2 d-flex justify-content-center"
                >
                    <FontAwesomeIcon
                        icon={isFavorite(product) ? SolidHeart : RegularHeart}
                        style={{
                            color: isFavorite(product) ? 'red' : 'gray',
                            fontSize: window.innerWidth <= 768 ? '18px' : '24px'
                        }}
                    />
                </div>
            </div>

            <div className="product-card-info">
                <h3 className="product-card-name fw-bold fs-6 fs-7">
                    {product.baslik}
                </h3>

                {/* Görüntülenme Metni */}
                <div className='d-flex align-items-center gap-2 wiev-count'>
                    <i className="fas fa-eye"></i>
                    <span>
                        {(product.view_count ?? 0).toLocaleString('tr-TR')} incelenme
                    </span>
                </div>

                <div className="ratingg">
                    {'★'.repeat(5)}
                </div>

                <div className="pricee">
                    {product.fiyat && product.eski_fiyat !== product.fiyat ? (
                        <div className="price-container gap-md-2 gap-1">
                            <p className="old-price line-through">
                                {product.eski_fiyat.toLocaleString('tr-TR')} TL
                            </p>
                            <p className="discountedd-price">
                                {product.fiyat.toLocaleString('tr-TR')} TL
                            </p>
                        </div>
                    ) : (
                        <p className="originall-price">
                            {product.fiyat.toLocaleString('tr-TR')} TL
                        </p>
                    )}
                </div>
                {product.stok === 0 && (
                    <p className="stock-warning" style={{ color: 'red', fontWeight: 'bold' }}>
                        Stok bulunamadı
                    </p>
                )}

                {!product.image.i1 && <p>Ürün fotoğrafı bulunamadı.</p>}
            </div>
        </a >



    );
};

export default ProductCard; 